import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// translations
// these are mostly derived from google translate, not native speakers. Quality is not assured.
// fr is a mix of cosmipolitane french from google translate and french canadian phrases provided by a client
// es is a combination of google translate and preexisting phrases that were left behind by a previous developer.
// spanish has numerous dialects and current spanish speaking sites are for mexicans.
// no complaints have been recieved to my knowledge.

// At some point it might be beneficial to spin off transaltions into their own json file.
const resources = {
  en: {
    translation: {
      backFromFilter: 'Return to locations list and other filtering tools.',
      clearFilter: 'Clear filter selection',
      closestLocations: 'Use my current location to generate a list of nearby locations',
      DaysOfTheWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      displayLocationsList: 'Full list of locations hidden.  Click link to view full list.',
      directionsLink: 'Open browser tab that includes Google Map directions',
      distance: 'distance',
      filters: 'filters',
      filtersContainer: 'filters container',
      filterResultsDescription: 'Advanced Search - Use filters to sort the list of locations below, opens modal',
      location: 'Location',
      locationLink: 'View the location detail page for this location',
      locationsList: 'List of locations with contact information',
      mapFilters: 'Map filter groups container',
      phoneNumber: 'Call this phone number',
      screenReaderIntro: 'List of locations, filtering tools, and a Google Map',
      searchWithFilters: 'Search for locations with search string and applied filters',
      streetAddress: 'Street Address',
      toSortListBelow: 'Enter Zip code or city, state to sort the list of locations below',
      'View Location': 'View Location',
    },
  },
  es: {
    translation: {
      'Advanced Search': 'Búsqueda Avanzada',
      Back: 'Volver',
      backFromFilter: 'Regrese a la lista de ubicaciones y otras herramientas de filtrado.',
      clearFilter: 'Borrar selección de filtros',
      close: 'cerrar',
      closestLocations: 'Usar mi ubicación actual para generar una lista de ubicaciones cercanas',
      DaysOfTheWeek: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
      displayLocationsList: 'Lista completa de ubicaciones ocultas. Haga clic en el enlace para ver la lista completa.',
      directionsLink: 'Abrir pestaña del navegador que incluye direcciones de Google Map',
      distance: 'distancia',
      'Enter five digit Zip code': 'Ingrese el código postal de cinco dígitos',
      'Enter Zip code or city, state': 'Ingrese el código postal, ciudad o estado',
      filters: 'filtros',
      filtersContainer: 'contenedor de filtros',
      filterResultsDescription: 'Búsqueda Avanzada - Use filtros para ordenar la lista de ubicaciones a continuación, abre modal',
      'Filter Search Results': 'Filtrar resultados de búsqueda',
      'Get Directions': 'Cómo llegar',
      Go: 'Ir',
      'Invalid Request': 'Solicitud no válida',
      location: 'Ubicación',
      locationLink: '',
      locationsList: 'Lista de ubicaciones con información de contacto',
      Loading: 'Cargando',
      'locations near you': 'ubicaciones cerca de ti',
      mapFilters: 'Asignar contenedor de grupos de filtros',
      'Max Distance': 'Distancia máxima',
      'No locations found': 'No se encontró ninguna ubicación',
      'No locations found with the selected filters': 'No se encontró ninguna ubicación con los términos seleccionados',
      phoneNumber: 'número de teléfono',
      'Please search for a location above': 'Utiliza el buscador para encontrar la ubicación deseada',
      Reset: 'Borrar',
      screenReaderIntro: 'Lista de ubicaciones, herramientas de filtrado y un mapa de Google',
      searchWithFilters: 'Busque ubicaciones con una cadena de búsqueda y filtros aplicados',
      streetAddress: 'Dirección',
      toSortListBelow: 'Ingrese el código postal o ciudad, estado para ordenar la lista de ubicaciones a continuación',
      'use my current location': 'utilizar mi ubicación actual',
      'View List': 'Ver Lista',
      'View Location': 'Más información',
      'View Results': 'Ver resultados',
      'We cannot find your current location. Please search for a location above': 'No se pudo encontrar tu ubicación actual. Utiliza el buscador para encontrar la ubicación deseada',
    },
  },
  fr: {
    translation: {
      'Advanced Search': 'Recherche Avancée',
      backFromFilter: 'Revenir à la liste des emplacements et aux autres outils de filtrage.',
      clearFilter: 'Effacer la sélection du filtre',
      close: 'proche',
      closestLocations: 'Utilisez les géocoordonnées actuelles pour générer une liste des emplacements à proximité',
      directionsLink: "Ouvrir l'onglet du navigateur qui inclut les directions de Google Map",
      displayLocationsList: 'Liste complète des emplacements cachés. Cliquez sur le lien pour voir la liste complète.',
      distance: 'distance',
      'Enter five digit Zip code': 'Entrez le code postal à cinq chiffres',
      'Enter Zip code or city, state': 'Entrez le code postal, la ville ou la province',
      filters: 'filtres',
      filtersContainer: 'conteneur de filtres',
      filterResultsDescription: 'Utiliser des filtres pour trier la liste des emplacements ci-dessous, ouvre modal',
      'Filter Search Results': 'Filtrer les résultats de la recherche',
      'Get Directions': 'Obtenir des directions',
      Go: 'Va',
      'Invalid Request': 'requête invalide',
      location: 'Leiu',
      locationLink: '',
      locationsList: 'Liste des lieux avec coordonnées',
      Loading: 'Chargement',
      'locations near you': 'Emplacements près de chez vous',
      mapFilters: 'Conteneur de groupes de filtres de carte',
      'Max Distance': 'Distance maximale',
      'No locations found': 'Aucun lieu trouvé',
      // 'No locations found with the selected filters': '',
      'Please search for a location above': 'Veuillez rechercher un emplacement ci-dessus',
      phoneNumber: 'numéro de téléphone',
      Reset: 'Réinitialiser',
      screenReaderIntro: 'Liste des emplacements, des outils de filtrage et une carte Google',
      searchWithFilters: 'Rechercher des emplacements avec une chaîne de recherche et des filtres appliqués',
      streetAddress: 'adresse de rue',
      toSortListBelow: "Entrez le code postal ou la ville, l'état pour trier la liste des emplacements ci-dessous",
      'use my current location': 'utiliser ma position actuelle',
      'View List': 'Afficher la liste',
      'View Location': "Voir l'emplacement",
      'View Results': 'Voir les résultats',
      'We cannot find your current location. Please search for a location above': 'Nous ne pouvons pas trouver votre position actuelle. Veuillez rechercher un emplacement ci-dessus',
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'es',
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
